/**
 * List of available display languages that the retailer can choose from.
 */ export var RETAILER_AVAILABLE_LOCALES = 'RETAILER_AVAILABLE_LOCALES';
